import React, { useContext,useCallback, useState, useEffect } from "react";
import Http from "../../../networkReq/http";
import zh_CN from "antd/es/locale/zh_CN";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Request from "../../../networkReq/request";
import Collected from "images/collected.png";
import CollectWork from "images/collectWork.png";
import "./index.scss";
import "../index.scss";
import {getcodeValue } from "@/utils/storage"
import {
  Card,
  Pagination,
  Button,
  ConfigProvider,
  Input,
  Select,
  Form,
  Row,
  Col,
} from "antd";
const jobData = [
  {
    name: "xxx职位",
    area: "眉山市 东坡区",
    companyName: "xxx公司",
    isDelivery: false,
    recruitmentNum: 100,
    salary: "13-17k",
    workYear: "3-5",
    education: "本科",
    type: "私营企业",
    enterpriseNum: "100-499",
    treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
    isCollection: false,
  },
  {
    name: "xxx职位",
    area: "眉山市 东坡区",
    companyName: "xxx公司",
    isDelivery: false,
    recruitmentNum: 100,
    salary: "13-17k",
    workYear: "3-5",
    education: "本科",
    type: "私营企业",
    enterpriseNum: "100-499",
    treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
    isCollection: false,
  },
  {
    name: "xxx职位",
    area: "眉山市 东坡区",
    companyName: "xxx公司",
    isDelivery: false,
    recruitmentNum: 100,
    salary: "13-17k",
    workYear: "3-5",
    education: "本科",
    type: "私营企业",
    enterpriseNum: "100-499",
    treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
    isCollection: false,
  },
]

export default function JobDetail() {
  const routeParmas = useParams()
  const history = useHistory();
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); //当前页数
  const [mapData,setMapData] = useState([])
  const [data, setData] = useState([]); //职位名称
  const [treatment, setTreatment] = useState(
    "通讯补贴，员工旅游，五险一金，定期体检"
  );
  const [humanAffairsName, setHumanAffairsName] = useState("公司简介"); //人事名称
  const [hiring, sethiring] = useState("招聘岗位"); //人事名称
  function itemRender(current, type, originalElement) {
    if (type === "prev") {
      return <a>上一页</a>;
    }
    if (type === "next") {
      return <a>下一页</a>;
    }
    return originalElement;
  }
  const handlePage = useCallback((page, pageSize) => {
    console.log(page,pageSize);
    setCurrentPage(page);
  }, []);
  const initiaList = ()=>{
    let params = {
      size:10,
      userId:routeParmas.id,
      current:currentPage,
    }
    Http.get(Request.companyDetailList(), {...params}, obj => {
      setData(obj.data?.records || [])
      setTotal(obj.data?.total || []);
  });
  }
  useEffect(() => {
    setData(jobData);
    setTotal(jobData?.total || [])
    console.log("jobDatajobDatajobDatajobDatajobData",jobData)
    console.log("------",history)
    console.log("------",routeParmas)
    console.log(total)
    let params = {
      userId:routeParmas.id
    }
    Http.get(Request.companyDetails(), {...params}, obj => {
      setMapData(obj?.data || [])
  });
    Http.get(Request.companyDetailList(), {...params}, obj => {
      setData(obj.data?.records || [])
      setTotal(obj.data?.total || [])

  });
  }, []);
  
  useEffect(() => {
    initiaList();
  }, [currentPage],);


  return (
    <div className={"my_companyDetails_app"}>
      <section className={"job_item_header"}>
        <div className={"job_item_title"}>
          <div className={"job_item_left"}>
            <span
              className={"job_item_name"}>
                {mapData.auditMechanismName}
              </span>
          </div>
		  <div
			className="backBtn"
			onClick={() => {
			  // this.props.history.replace("/entrance/education");
			  window.history.back(-1);
			}}
		  >
			返回
		  </div>
          {/* <div>
          <Button className={"job_item_button"}  value="large" >{isDelivery ? <img
            src={isCollection ? Collected : CollectWork}
            alt=""
            style={{ marginBottom: 4,marginRight: 6 }}
          />: ""}  收藏职位</Button>
          <Button className={"job_item_button"} disabled={isDelivery ? true : false}  type={isDelivery ? "dashed" : "primary"}>{isDelivery ? "已投递" : "投递简历"}</Button>
          </div> */}
        </div>
        <div className={"job_item_left"}>
          <span className={"job_item_treatment"}>{mapData.auditMechanismScale}</span>
        </div>
      </section>
      {/* 岗位信息及要求 */}
      <section className="job_item_require_infos">
        <div className="job_item_require_detail">
          <div>
            <div className="job_item_human_affairs">
              <div className="human_affairs_infos">
                <div className="human_affairs_name">{humanAffairsName}</div>
                <div className="job_footer_border"></div>
                <div className="phone_job_deadline_time">
                  <div className="human_affairs_phone">
                    {mapData.auditMechanismIntroduce}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="job_item_section">
                <div className="human_affairs_name">{hiring}</div>
                <div className="job_footer_border"></div>
            </div>
            {data.map((item, index) => {
              return (
                <section className={"job_item_header"}>
                <div className={"job_item_title"}>
                  <div className={"job_item_left"}>
                    <span
                      className={"job_item_name"}>
                        {item.job}
                      </span>
                    <span className={"job_item_area"}>{item.salary}</span>
                  </div>
                  <div className="job_item_right">
                  <Button className={"job_item_button"}  value="large" >{<img
                    src={item.favoriteOrNot == 1 ? Collected : CollectWork}
                    alt=""
                    style={{ marginBottom: 4,marginRight: 6 }}
                  />}  收藏职位</Button>
                  <Button className={"job_item_button"} disabled={item.resumeOrNot == 1 ? true : false}  type={item.resumeOrNot == 1 ? "dashed" : "primary"}>{item.resumeOrNot == 1 ? "已投递" : "投递简历"}</Button>
                 
                  </div>
                </div>
                <div className={"job_item_left"}>
                  <span className={"job_item_treatment"}>{item.workArea} · {item.workExperience} · {getcodeValue('edu_lev_code',item.degree)}</span>
                </div>
              </section>
              );
            })} */}
        {/* <ConfigProvider locale={zh_CN}>
          <Pagination
            total={total}
            itemRender={itemRender}
            showQuickJumper={{
              goButton: <Button className={"pagination_jump"}>确定</Button>,
            }}
            showTotal={(total) => `共 ${total} 条`}
            onChange={handlePage}
            showSizeChanger={false}
            current={currentPage}
            defaultPageSize={10}
            style={{
              marginTop: 14,
              paddingRight: 24,
              display: "flex",
              justifyContent: "flex-end",
            }}
          />
        </ConfigProvider> */}
          </div>
          {/* 职位描述 */}
          {/* <div className="job_describe_info">
            <div className="job_require_describes">福利待遇</div>
            <div className="job_footer_border"></div>
            <div className="job_p">公司入职就购买社保、缴纳五险一金、每年组</div>

            <div className="job_describes">
              <div className="job_require_describes">职位描述</div>
              <div className="job_footer_border"></div>
              <div className="job_info_p">
                <div>
                  <span className="job_info_titles">招聘人数：</span>
                  <span className="job_info_require">{jobNum}</span>
                </div>
                <div>
                  <span className="job_info_titles">到岗时间：</span>
                  <span className="job_info_require">{arriveTime}</span>
                </div>
                <div>
                  <span className="job_info_titles">年龄要求：</span>
                  <span className="job_info_require">{ageRequire}</span>
                </div>
                <div>
                  <span className="job_info_titles">性别要求：</span>
                  <span className="job_info_require">{genderRequire}</span>
                </div>
            </div>
              <div className="job_info_titles">职位描述：</div>
              <div>
                {jobDescribe.map((item, index) => {
                  const element = (
                    <div key={index}>
                      <span className="job_info_titles">{index + 1}、</span>
                      <span className="job_info_titles">{item}</span>
                    </div>
                  );
                  return element;
                })}
              </div>
              <div className="job_info_titles">任职要求：</div>
              <div>
                {jobDescribe.map((item, index) => {
                  const element = (
                    <div key={index}>
                      <span className="job_info_titles">{index + 1}、</span>
                      <span className="job_info_titles">{item}</span>
                    </div>
                  );
                  return element;
                })}
              </div>
            </div>
          </div> */}
        </div>
        <div className="job_item_Broken_info"></div>
        <div className="job_item_company_info">
          <div className="human_affairs_name">公司基本信息</div>
          <div className="job_footer_border"></div>
          <div className="job_item_company_name">{mapData.auditMechanismName}</div>
          <div>
            <span className="company_info_job_num_label">联系人：</span>
            <span className="company_info_job_num">{mapData.auditMechanismContacts}</span>
          </div>
          <div>
            <span className="company_info_job_num_label">联系电话：</span>
            <span className="company_info_job_num">{mapData.phone}</span>
          </div>
          <div>
            <span className="company_info_job_num_label">企业邮箱：</span>
            <span className="company_info_job_num">{mapData.email}</span>
          </div>
          <div>
            <span className="company_info_job_num_label">公司地址：</span>
            <span className="company_info_job_num">{mapData.auditMechanismAddress}</span>
          </div>
          
        </div>
      </section>
    </div>
  );
}
